import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';

import { SearchSuggestion } from 'types/searchSuggestion';
import { getHighlightedSearchField } from 'helpers/utils/search/searchSuggestion';
import TapOn from 'components/Icons/TapOn';
import { updateSearchField } from 'store/searchSuggestions/action';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'store/types';
import { isEligible } from 'store/app/selector';


interface ButtonProps {
  textColor: string;
}

const Button = styled.button`
  outline: none;
  background: none;
  border: none;
  width: 100%;
  text-align: start;
  color: ${({ textColor }: ButtonProps) => textColor};
  ${({ theme }) => theme.typography.bodyMedium};
`;

interface OtherSuggestionProps {
  suggestion: SearchSuggestion;
  searchField: string;
  index: number;
  handleClick: (suggestion: SearchSuggestion, position: number) => void;
}

const SuggestionWrapper = styled.div`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  text-decoration: none;
  border: 1px solid #e1e1e1;
  padding: 15px;
  text-align: start;
  width: 100%;
`;

const TapOnWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FlexRight = styled.div`
  margin-left: -20px;
`;

function OtherSuggestion({
  suggestion,
  searchField,
  handleClick,
  index,
}: OtherSuggestionProps) {
  const theme: Theme = useTheme();
  const dispatch = useDispatch();
  let { q } = suggestion;
  const { partBefore, partMatching, partAfter, match } = getHighlightedSearchField(searchField, q);
  const handleTapOn = () => {
    const updatedQuery = `${q} `;
    updateSearchField(updatedQuery)(dispatch);
  };
  const runValue = useSelector((state: State) => state.appReducer.run);
  const tapOnConfigs = useSelector((state: State) => state.remoteConfig.configs.AB?.autocompleteTapOn);
  const isTapSuggestionsOnEnabled = isEligible(tapOnConfigs, runValue);
  return (
    <SuggestionWrapper>
      <Button
        textColor={theme.darkGrey}
        key={q}
        type="button"
        onClick={() => handleClick(suggestion, index + 1)}
      >
        {
        match ? (
          <span>
            {partBefore}
            <b>{partMatching}</b>
            {partAfter}
          </span>
        ) : (
          q
          )
        }
      </Button>
      {isTapSuggestionsOnEnabled && (
        <FlexRight>
          <TapOnWrapper onClick={() => handleTapOn()}>
            <TapOn />
          </TapOnWrapper>
        </FlexRight>
      )}
    </SuggestionWrapper>
  );
}

export default OtherSuggestion;
